import { Component, OnInit, RendererFactory2, Renderer2, Inject } from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router, ActivatedRouteSnapshot, NavigationEnd, ActivatedRoute} from '@angular/router';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import dayjs from 'dayjs/esm';
import {AccountService} from 'app/core/auth/account.service';
import {Account} from "../../core/auth/account.model";
import {UserData} from "../../models/user-data";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import { Observable, take, throwError } from 'rxjs';
import { catchError, filter } from 'rxjs/operators';
import {LoginService} from "../../login/login.service";
import {Visura} from "../../models/visura";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {ConfigurazioneGeneraleService} from "../../services/configurazione-generale.service";
import {StateStorageService} from "../../core/auth/state-storage.service";
import { AmministrazioneService } from '../../services/amministrazione.service';
import { HomePageHeaderFooter } from '../../models/home-page-header-footer.model';
import { Configurazione } from '../../models/configurazione';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'jhi-main',
  templateUrl: './main.component.html',
})
export class MainComponent extends SubscriptionManager implements OnInit, HttpInterceptor {
  account: Account | null = null;
  homePageHeaderFooter?: HomePageHeaderFooter;
  public userData!: UserData;
  public visura!: Visura;
  configurazione!: Configurazione;
  private renderer: Renderer2;
  private urlToIgnore: Array<string>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private loginService: LoginService,
    private accountService: AccountService,
    private titleService: Title,
    private router: Router,
    private translateService: TranslateService,
    protected configurazioneService: ConfigurazioneGeneraleService,
    private stateStorageService: StateStorageService,
    private amministrazioneService: AmministrazioneService,
    rootRenderer: RendererFactory2
  ) {
    super();
    this.renderer = rootRenderer.createRenderer(document.querySelector('html'), null);
    this.urlToIgnore = [
      "/ca/",
      "/ca/lista-servizi",
      "/ca/Appuntamenti/prenota-nuovo-appuntamento",
      "/ca/Appuntamenti/inserimento-dati-prenotazione",
      "/ca/Appuntamenti/scelta-servizi-prenotazione",
      "/ca/Appuntamenti/scelta-data-ora-prenotazione",
      "/ca/Appuntamenti/riepilogo-prenotazione"
    ]
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown> | any> {
    if (!((request.url.includes("api/account") || request.url.includes("pn-utente/logged-user")) && (this.urlToIgnore.includes(window.location.pathname.toString())))) {
      return next.handle(request).pipe(
        catchError(err => {
          switch (err.status) {
            case 400:
              return throwError(() => new HttpErrorResponse(err));
            case 401:
              console.log("sono entrato " + request.url);
              console.log("url pagina " + location.pathname+location.search);
              this.stateStorageService.storeUrl((location.pathname+location.search));
              window.onbeforeunload = null;
              this.loginService.login();
              return throwError(() => new HttpErrorResponse(err));
            case 403:
              void this.router.navigate(['accessdenied']);
              return throwError(() => new HttpErrorResponse(err));
            case 404:
              if( err.error.messaggio === '' ||  err.error.messaggio == null){
                err.error.messaggio = 'Pagina non disponibile'
              }
              return throwError(() => new HttpErrorResponse(err));
            case 500:
              //  alert("Errore interno al server (500)")
              /*if (!err.error.codice) {
                void this.router.navigate(['error']);
              } */
              return throwError(() => new HttpErrorResponse(err));
            default:
              return throwError(() => new HttpErrorResponse(err));
          }
          // return of(err)
        })
      );
    }
    return next.handle(request);
  }

  ngOnInit(): void {
    this.configurazioneService.getAllImpostazioni();
    this.configurazioneService.configurazione$
      .pipe(filter(configurazione => configurazione !== null), take(1))
      .subscribe(configurazione => {
        this.configurazione = configurazione!;
        this.setFavicon(this.configurazione.favicon);
      });
    // try to log in automatically
    this.subs.sink = this.accountService.identity().subscribe();
    this.subs.sink = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateTitle();
      }
    });

    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.updateTitle();
      dayjs.locale(langChangeEvent.lang);
      this.renderer.setAttribute(document.querySelector('html'), 'lang', langChangeEvent.lang);
    });

    this.subs.sink = this.accountService.identity().subscribe({
      next: acc => {
        this.account = acc;
        this.loginService.isLoggedIn = true;
      },
      complete: () => {
        if (this.account != null) {
          this.subs.sink = this.accountService.getLoggedUser().subscribe((data) => {
            this.userData = data;
            this.accountService.loggedSubject.next();
              localStorage.setItem('userData', JSON.stringify(this.userData));
          })
        }
      }
    });
  }

  private setFavicon(faviconBase64: string): void {
    const faviconUrl = `data:image/png;base64,${faviconBase64}`;
    let link: HTMLLinkElement | null = this.document.querySelector("link[rel~='icon']");
    if (!link) {
      link = this.document.createElement('link');
      link.rel = 'icon';
      this.document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }

  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
    const title: string = routeSnapshot.data['pageTitle'] ?? '';
    if (routeSnapshot.firstChild) {
      return this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    return title;
  }

  private updateTitle(): void {
    let pageTitle = this.getPageTitle(this.router.routerState.snapshot.root);
    if (!pageTitle) {
      pageTitle = 'global.title';
    }
    this.subs.sink = this.translateService.get(pageTitle).subscribe(title => this.titleService.setTitle(title));
  }
}
